export default "__VITE_ASSET__BVF7_mXt__"